import { graphql } from "generated/gql";

export const createMaterialImagesDocument = graphql(/* GraphQL */ `
  mutation CreateMaterialImages(
    $materialId: ID!
    $input: [CreateMaterialImageFromUrlInput!]!
  ) {
    createMaterialImages(materialId: $materialId, input: $input) {
      success
      materialImages {
        id
      }
    }
  }
`);
